import {ViewIcon, ViewOffIcon} from "@chakra-ui/icons";
import {
  Button,
  Container,
  FormControl,
  FormLabel, Heading,HStack,
  IconButton, Input, InputGroup, InputRightElement,
  Spinner,
  Text, VStack,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, {useEffect, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  LoginParams,
  useAuthentication,
} from "../hooks/AuthenticationProvider";
import {disableBlurProtection} from "../hooks/BlurProtection";
import {useFont} from "../hooks/FontProvider";
import {useTheme} from "../hooks/ThemeProvider";
import {AppTheme, customButtonProps, Paths} from "../model/Constants";
import {enableKeyCommands, getTheme, isInAvataiSite} from "../Utils";

interface LocationState {
  from: Location;
}

const Login = (props: {isDemo?:boolean}) => {
  const [show, setShow] = useState(false)
  //const [theme, setTheme] = useState<AppTheme>(getTheme());
  const themeContext = useTheme();
  const font = useFont().font;
  const handleClick = () => setShow(!show)

  const isAvatai = isInAvataiSite();

  const authentication = useAuthentication();
  const location = useLocation();
  const navigate = useNavigate();

  disableBlurProtection();
  enableKeyCommands();

  const from : string = (location.state as LocationState)?.from?.pathname || "/";
  const redirectToPreviousLocation = () => {
    navigate(from, { replace: true });
  };

  useEffect(() => {
    if ( authentication.currentUserQuery && authentication.currentUserQuery.data &&
      authentication.currentUserQuery.isSuccess &&
      authentication.currentUserQuery.data.status !== 401
    ) {
        if (props.isDemo) sessionStorage.setItem('isDemo', 'true');
        else sessionStorage.setItem('isDemo', '');
      redirectToPreviousLocation();
    }
  }, [authentication.currentUserQuery, redirectToPreviousLocation]);

  if (
    !authentication.currentUserQuery ||
    authentication.currentUserQuery.isLoading
  ) {
    return <Spinner />;
  }

  return (
    <Container maxW="container.sm" paddingY="2em"
          filter= {'grayscale('+themeContext.theme.IMG_GRAYSCALE+') contrast('+themeContext.theme.IMG_CONTRAST+')'}>
       { props.isDemo &&
        <Heading maxW="md" textAlign="center" placeSelf="center">
          Prueba de Práctica
        </Heading>
        }
      <Formik
        initialValues={
          {
            username: "",
            password: "",
          } as LoginParams
        }
        onSubmit={(values: LoginParams) =>{
            /*const finalValues: LoginParams = {
                username: (props.isDemo? "p":"") + values.username,
                password: (props.isDemo? "p":"") + values.password,
                };
*/
            authentication.loginMutation?.mutate(values);
          }
        }
      >
        <Form>
          <Field name="username">
            {({ field }: any) => (
              <FormControl>
                <FormLabel htmlFor="username"
                   fontSize={font.p}>Usuario</FormLabel>
                <Input {...field} borderColor={themeContext.theme.OUTLINE} id="username" />
              </FormControl>
            )}
          </Field>
          <Field name="password">
            {({ field }: any) => (
              <FormControl>
                <FormLabel htmlFor="password"
                   fontSize={font.p}>Contraseña</FormLabel>

                <InputGroup>
                  <Input {...field} borderColor={themeContext.theme.OUTLINE} id="password" type={show ? 'text' : 'password'} />
                  <InputRightElement >
                    <IconButton aria-label={"Mostrar"}
                                backgroundColor="transparent"
                                onClick={handleClick}
                                icon={show ? <ViewOffIcon /> : <ViewIcon />} />
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            )}
          </Field>
          <HStack
            mt={4} >
            {isAvatai && <Button
              {...customButtonProps(isAvatai)}
              onClick={()=>navigate(Paths.AVATAI_INTRO)}
            >
              Volver
            </Button>}
            <Button
              {...customButtonProps(isAvatai)}
                   fontSize={font.p}
              type="submit"
                _dark={{ color: "black" }}
              isLoading={authentication.loginMutation?.isLoading}
            >
              Entrar
            </Button>
          </HStack>
          {authentication.currentUserQuery.isRefetchError && (
            <Text mt={4}
                   fontSize={font.p}>Su sesión expiró</Text>
          )}
          {authentication.loginMutation?.isError && (
            <Text mt={4}
                   fontSize={font.p}>Por favor revise su usuario y contraseña</Text>
          )}
        </Form>
      </Formik>
    </Container>
  );
};

export default Login;
